import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import { invoice_img } from '../config.js';
import { IndianCurrencyFormatter, FormatDate } from '../Function';

const parseNotes = (notes) => {
    if (!notes) return null;
    try {
        if (typeof notes === 'string' && notes.trim().startsWith('{')) {
            return JSON.parse(notes);
        }
        return { text: notes };
    } catch {
        return { text: notes };
    }
};

const getReceiptTitle = (type) => {
    switch (type) {
        case 'commission_payments':
            return 'Commission Payment Receipt';
        case 'admin_payments':
            return 'Admin Payment Receipt';
        default:
            return 'Payment Receipt';
    }
};

const getStatusBadge = (status) => {
    if (status === 'completed' || status === 'paid') {
        return <span className="badge badge-success">Completed</span>;
    }
    if (status === 'pending') {
        return <span className="badge badge-warning">Pending</span>;
    }
    return <span className="badge badge-secondary">{status || 'Unknown'}</span>;
};

export default function TransactionReceipt() {
    const navigate = useNavigate();
    const location = useLocation();
    const { fulluser } = useContext(AuthContext);
    const { item, type, vendor } = location.state || {};
    const vendorInfo = vendor || fulluser;
    const parsedNotes = parseNotes(item?.notes);

    if (!item || !type) {
        return (
            <div id="appCapsule">
                <div className="section mt-4">
                    <div className="card">
                        <div className="card-body text-center py-5">
                            <p className="text-muted mb-3">No payment details found.</p>
                            <button type="button" className="btn btn-primary" onClick={() => navigate(-1)}>
                                Go Back
                            </button>
                        </div>
                    </div>
                </div>
                <Footer />
                <Sidebar />
            </div>
        );
    }

    const isCommission = type === 'commission_payments';
    const amountColor = isCommission ? '#dc3545' : '#28a745';

    return (
        <div id="appCapsule">
            <div className="row mt-2">
                <div className="col-12">
                    <div className="stat-box mt-2">
                        <center>
                            <img
                                style={{ marginTop: '6%', width: '70px' }}
                                src={invoice_img}
                                alt="receipt"
                                className="image-block imaged"
                            />
                        </center>
                        <h1 style={{ fontWeight: '700', color: amountColor }} className="mt-2 text-center">
                            <IndianCurrencyFormatter amount={item.amount} />
                        </h1>
                        <p className="text-center text-muted mb-1">{getReceiptTitle(type)}</p>
                        <p className="text-center"><b>{FormatDate(item.created_at)}</b></p>
                        <br />
                        <b style={{ color: 'black' }}>Payment Details</b>
                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <th scope="col"><b>Transaction ID</b></th>
                                    <th scope="col"><b>#{item.id}</b></th>
                                </tr>
                                <tr>
                                    <th scope="col"><b>Description</b></th>
                                    <th scope="col"><b>{item.description || 'N/A'}</b></th>
                                </tr>
                                <tr>
                                    <th scope="col"><b>Status</b></th>
                                    <th scope="col"><b>{getStatusBadge(item.status)}</b></th>
                                </tr>
                                <tr>
                                    <th scope="col"><b>Payment Method</b></th>
                                    <th scope="col">
                                        <b>{(item.payment_method || 'N/A').toUpperCase()}</b>
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="col"><b>Direction</b></th>
                                    <th scope="col">
                                        <b>{(item.direction || 'N/A').replace(/_/g, ' ')}</b>
                                    </th>
                                </tr>
                                {item.pay_date && (
                                    <tr>
                                        <th scope="col"><b>Pay Date</b></th>
                                        <th scope="col"><b>{FormatDate(item.pay_date)}</b></th>
                                    </tr>
                                )}
                                {vendorInfo?.shop_name && (
                                    <tr>
                                        <th scope="col"><b>Shop</b></th>
                                        <th scope="col"><b>{vendorInfo.shop_name}</b></th>
                                    </tr>
                                )}
                                {isCommission && parsedNotes?.razorpay_payment_id && (
                                    <tr>
                                        <th scope="col"><b>Razorpay Payment ID</b></th>
                                        <th scope="col">
                                            <b style={{ fontSize: '12px', wordBreak: 'break-all' }}>
                                                {parsedNotes.razorpay_payment_id}
                                            </b>
                                        </th>
                                    </tr>
                                )}
                                {isCommission && parsedNotes?.razorpay_order_id && (
                                    <tr>
                                        <th scope="col"><b>Razorpay Order ID</b></th>
                                        <th scope="col">
                                            <b style={{ fontSize: '12px', wordBreak: 'break-all' }}>
                                                {parsedNotes.razorpay_order_id}
                                            </b>
                                        </th>
                                    </tr>
                                )}
                                {!isCommission && item.payout_id && (
                                    <tr>
                                        <th scope="col"><b>Payout / Reference ID</b></th>
                                        <th scope="col"><b>{item.payout_id}</b></th>
                                    </tr>
                                )}
                                {parsedNotes?.text && (
                                    <tr>
                                        <th scope="col"><b>Notes</b></th>
                                        <th scope="col"><b>{parsedNotes.text}</b></th>
                                    </tr>
                                )}
                                <tr>
                                    <th scope="col"><b>Amount</b></th>
                                    <th scope="col">
                                        <b style={{ fontSize: '18px', color: amountColor, fontWeight: '700' }}>
                                            <IndianCurrencyFormatter amount={item.amount} />
                                        </b>
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                        <br />
                        <center>
                            <button type="button" className="btn btn-outline-primary" onClick={() => navigate(-1)}>
                                Back to History
                            </button>
                        </center>
                    </div>
                </div>
            </div>
            <Footer />
            <Sidebar />
        </div>
    );
}
